import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-32 md:w-48 h-9 md:h-12 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/9700cfc123ce22cf391e77d50f0f2b6c/16042ced149becdaff7cadb9beefd742.png"
                alt="株式会社万燈"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          
          <a
            href="https://form.run/@yachinzero"
            target="_blank"
            rel="noopener noreferrer"
            className={`px-4 md:px-8 py-2 md:py-3 rounded-lg text-sm md:text-base font-bold transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105 ${
              isScrolled 
                ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white hover:from-amber-600 hover:to-amber-700' 
                : 'bg-white text-gray-900 hover:bg-gray-50'
            }`}
          >
            個別面談申込
          </a>
        </div>
      </div>
    </header>
  );
}
